import React, { useEffect, useState, useRef } from "react";
import StyledTable from "../../../Components/Table/index";
import ExploreData from "./bodyData";
import { Register } from "./Register";
import { useDispatch } from "react-redux";
import { ExploreLabel } from "./Labels";
import { PrimaryButton } from "../../../Components/Button";
import { AppContainer } from "../../../Components/Global/Reusable";
import { setExploreRegisterState } from "../../../features/MenuSlice";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Hooks/useAuth";
import { Toast } from "../../../Components/Toast";

export default function Index() {
  const [actualEditId, setActualEditId] = useState("");
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    title: "",
    variation: "",
  });
  const [secondaryFilter] = useState("");
  const [orderFilter, setOrderFilter] = useState(null);

  const timerRef = useRef(0);
  const dispatch = useDispatch();

  function toggleToast(isOpen) {
    setIsToastOpen(isOpen);
  }

  function onToastOpen(title, variation) {
    setToastMessage({ title: title, variation: variation });
    toggleToast(false);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(function () {
      toggleToast(true);
    }, 100);
  }

  function editItem(id) {
    setActualEditId(id);
    dispatch(setExploreRegisterState());
  }

  function closeRegister() {
    dispatch(setExploreRegisterState());
    setActualEditId("");
  }

  const navigate = useNavigate();
  const { currentUserData, logout } = useAuth();

  useEffect(() => {
    if (currentUserData && currentUserData.role === "user") {
      (async () => {
        await logout();
        navigate("/admin/login");
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Toast
        variation={toastMessage.variation}
        title={toastMessage.title}
        open={isToastOpen}
        onOpenChange={toggleToast}
      />
      <AppContainer maxWidth="xl">
        <StyledTable
          TableTitle="ConnectWatch"
          Component={
            <PrimaryButton onClick={() => dispatch(setExploreRegisterState())}>
              Cadastrar Novo
            </PrimaryButton>
          }
          Labels={
            <ExploreLabel
              orderFilter={orderFilter}
              setOrderFilter={setOrderFilter}
            />
          }
          TableData={
            <ExploreData
              onToastOpen={onToastOpen}
              editItem={editItem}
              orderFilter={orderFilter}
              secondaryFilter={secondaryFilter}
            />
          }
        />
        <Register
          onToastOpen={onToastOpen}
          editId={actualEditId}
          closeRegister={closeRegister}
        />
      </AppContainer>
    </>
  );
}
